import Layout from '@/views/layout/TheLayout.vue';

function createItem(menu) {
  const item = {
    path: `${menu.path}`,
    alias: menu.id,
    name: menu.id,
    component: () => import('@/organisms/MenuItemView.vue'),
    meta: {
      icon: menu.icon,
      title: menu.id,
      affix: true,
      ...menu.meta,
    },
    props: (route) => ({ meta: route.meta }),
    parentId: menu.parentId,
    priority: menu.priority,
    children: [],
  };
  if (menu.children) {
    menu.children.forEach((child) => { item.children.push(createItem(child)); });
  }

  return item;
}

function registryRouteFactory(menu) {
  const menuItem = createItem(menu);

  menuItem.path = '/';
  menuItem.component = Layout;
  return menuItem;
}

export default registryRouteFactory;
